var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"apiKey":"1h193nv0nhtkgi8wi1wuep8rnz2bgtuwhidwspabwimf8ztv","init":_vm.init,"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }